'use client';
import { ReactNode } from 'react';

import { I18nextProvider } from 'react-i18next';

import i18next from '../i18n/config';

export const i18n = i18next;

export default function LocalizationProvider({
  children,
}: Readonly<{
  children: ReactNode;
}>) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
